export default __webpack_public_path__ + "static/media/airlockz-blk-2.21521a6c.png";